var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EntityCustomFields',{attrs:{"items":_vm.items,"entityId":this.$route.params.categoryId,"entity":'categories'},on:{"onRefresh":_vm.onRefresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }